<!-- ResponseBox.vue -->
<template>
   <div class="custom-container-1440 ">
      <div class="container-ques">
         <i class="circle-shape font-icon-brought-center fc-icon-chat-que"></i>
         <div class="question-box">
            <div :id="'question' + index" :tabindex="index" class="question response-message">
               <pre class="question_pre">{{ question }}</pre>
            </div>
         </div>
      </div>
      <div class="container-res">
         <i class="circle-shape font-icon-brought-center fc-icon-chat"></i>
         <div :id="'response' + index" class="response-box">
            <div ref="clone" class="response-message" v-html="renderMarkdown(response)"></div>
            <!--   <button @click="copy(response)">Copy</button> -->
         </div>
      </div>
   </div>
</template>

<script>
import marked from 'marked';
import Prism from 'prismjs';
import 'prismjs/components/prism-json';
// import "prismjs/themes/prism-twilight.css";
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-bash';
// or import markdown-it
export default {
   props: {
      question: {
         type: String,
         default: '', // Set your default value here
      },
      response: {
         type: String,
         default: '', // Set your default value here
      },
      index: {
         type: Number,
         default: 0, // Set your default value here
      },
   },
   updated() {
      // Get the div element
      // const divElement = document.getElementById(`response${index}`);
      // Scroll to the bottom of the div

      // divElement.scrollTop = divElement.scrollHeight;
      Prism.highlightAll();
      async function copyCode(block, button) {
         const code = block.querySelector('code');
         const text = code.innerText;

         navigator.permissions.query({ name: 'clipboard-write' }).then(result => {
            if (result.state === 'granted' || result.state === 'prompt') {
               navigator.clipboard.writeText(text).then(
                  () => {
                     // console.log("Copied!");
                  },
                  error => {
                     // console.log(error);
                  }
               );
            }
         });

         // visual feedback that task is completed
         button.innerText = 'Copied';
      }
      const copyButtonLabel = 'Copy';

      // use a class selector if available
      const blocks = document.querySelectorAll('pre');

      blocks.forEach(block => {
         // debugger;
         if (block.childElementCount === 1) {
            // only add button if browser supports Clipboard API
            if (navigator.clipboard) {
               const button = document.createElement('button');

               button.innerText = copyButtonLabel;
               button.classList.add('copyclass');
               button.setAttribute('data-tooltip', 'Copy Code');
               block.appendChild(button);
               button.addEventListener('click', async () => {
                  await copyCode(block, button);
               });
            }
         }
      });
   },
   mounted() {
      // debugger;
      /* document.getElementById(`question${this.index}`).scrollIntoView( {
  behavior: 'smooth',
  block: 'start'
}); */
      const element = document.getElementById(`response${this.index}`);
      const offset = 100; // Adjust this value as needed
      const topPos = element.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
         top: topPos,
         behavior: 'smooth',
      });
      Prism.highlightAll();

      async function copyCode(block, button) {
         const code = block.querySelector('code');
         const text = code.innerText;
         const delay = delayInms => new Promise(resolve => setTimeout(resolve, delayInms));
         //  debugger;
         if (
            !(
               navigator.userAgent.indexOf('Firefox') !== -1 ||
               (navigator.userAgent.indexOf('Safari') !== -1 &&
                  navigator.userAgent.indexOf('Chrome') === -1)
            )
         ) {
            // check if the browser is not Firefox and safari
            navigator.permissions.query({ name: 'clipboard-write' }).then(result => {
               if (result.state === 'granted' || result.state === 'prompt') {
                  navigator.clipboard.writeText(text).then(
                     () => {
                        // console.log("Copied!");
                     },
                     error => {
                        // console.log(error);
                     }
                  );
               }
            });
         } else {
            // Fallback for browsers without Permissions API
            navigator.clipboard
               .writeText(text)
               .then(() => {
                  // console.log("Copied without Permissions API!");
               })
               .catch(err => {
                  // console.error("Fallback copy failed: ", err);
               });
         }

         // visual feedback that task is completed
         button.innerText = 'Copied';
         await delay(3000);
         button.innerText = 'Copy';
      }

      const copyButtonLabel = 'Copy';

      // use a class selector if available
      const blocks = document.querySelectorAll('pre');

      blocks.forEach(block => {
         if (block.childElementCount === 1) {
            // only add button if browser supports Clipboard API
            if (navigator.clipboard) {
               const button = document.createElement('button');

               button.innerText = copyButtonLabel;
               button.classList.add('copyclass');
               button.setAttribute('data-tooltip', 'Copy');
               block.appendChild(button);
               button.addEventListener('click', async () => {
                  await copyCode(block, button);
               });
            }
         }
      });
   },
   methods: {
      updateClipboard(newClip) {
         navigator.clipboard.writeText(newClip).then(
            () => {
               // console.log("Copied!");
            },
            error => {
               // console.log(error);
            }
         );
      },

      /* copy(text_to_copy) {
      debugger;
      navigator.permissions
      .query({ name: "clipboard-write" })
      .then((result) => {
         if (result.state === "granted" || result.state === "prompt") {

         this.updateClipboard(text_to_copy);
         }
      });
    }, */

      renderMarkdown(markdown) {
         // Convert Markdown to HTML using marked library
         return marked(markdown, {
            highlight(code, lang) {
               // debugger;
               // const validLang = lang && Prism.languages[lang] ? lang : 'plaintext';
               const validLang = lang && Prism.languages[lang] ? lang : 'typescript';
               return Prism.highlight(code, Prism.languages[validLang], validLang);
            },
         });

         // /return marked(markdown);
      },
   },
};
</script>

<style scoped>
pre[class*='language-'] {
   position: relative;
   overflow: auto;

   /* make space  */
   margin: 5px 0;
   padding: 1.75rem 0 1.75rem 1rem;
   border-radius: 10px;
}

pre[class*='language-'] button {
   position: absolute;
   top: 5px;
   right: 5px;

   font-size: 0.9rem;
   padding: 0.15rem;
   background-color: #828282;

   border: ridge 1px #7b7b7c;
   border-radius: 5px;
   text-shadow: #c4c4c4 0 0 2px;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
}

pre[class*='language-'] button:hover {
   cursor: pointer;
   background-color: #bcbabb;
}

.tooltip {
   position: relative;
}

.tooltip::after {
   content: attr(data-tooltip);
   position: absolute;
   bottom: 100%;
   left: 50%;
   transform: translateX(-50%);
   background-color: rgba(0, 0, 0, 0.7);
   color: #fff;
   padding: 5px;
   border-radius: 5px;
   opacity: 0;
   transition: opacity 0.3s ease;
   pointer-events: none; /* Ensures the tooltip doesn't interfere with button clicks */
}

.tooltip:hover::after {
   opacity: 1;
}
.question_pre {
   background: none;
   margin-bottom: 0px;
   padding: 0px;
   font-size: 1.6rem;
   font-weight: normal;
   color: inherit;
   font-family: inherit;
}
.response-message img {
   max-width: 100%;
}
</style>
